/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Anuluj',
    CONFIRM: 'Potwierdzenie',
    SAVE: 'Zapisz'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Sieci społecznościowe',
    USERNAME: 'Nazwa użytkownika'
  },
  LABEL: {
    CREATE_LINK: 'Dodaj sieć społecznościową',
    EDIT_LINK: 'Edytuj sieć społecznościową',
    INACTIVATE_LINK: 'Usuń sieć społecznościową',
    INACTIVATE_LINK_MODAL_TITLE: 'Usuń sieć społecznościową',
    LINK: 'Link',
    SOCIAL_NETWORK: 'Sieci społecznościowe',
    USERNAME: 'Nazwa użytkownika'
  },
  SENTENCE: {
    ERROR: 'Błąd',
    INACTIVATE_LINK_TEXT: 'Czy na pewno chcesz usunąć sieć społecznościową?',
    NO_ROWS_LINKS: 'Brak mediów społecznościowych'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Sieć społecznościowa skutecznie wyeliminowana',
    LINKS_DETAILS_SAVED: 'Sieć społecznościowa została pomyślnie zapisana',
    LINKS_DETAILS_UPDATED: 'Pomyślna aktualizacja sieci społecznościowej',
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Sieci społecznościowe',
    USERNAME: 'Nazwa użytkownika'
  }
};
